import { AnyObject, API, snakeify } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

export type RequestType =
  | "referral"
  | "sales"
  | "demo"
  | "quote"
  | "trial"
  | "general"
  | "quota"
  | "jane";

type Args = {
  fields: Record<string, string>;
  requestType: RequestType;
};

const [useCreateSupportRequest, createSupportRequest] = createAsyncAction(
  "support/createRequest",
  async ({ fields, requestType }: Args) => {
    return await API.call<AnyObject>({
      endpoint: "support/requests/",
      method: "POST",
      data: {
        ...snakeify(fields),
        request_type: requestType,
      },
    });
  }
);

export default useCreateSupportRequest;
export { createSupportRequest };
